const Loader = () => {
  return (
    <div className={"d-flex justify-content-center align-items-center m-auto"}>
      <i
        className={"fa fa-spinner fa-spin fa-4x"}
        style={{ color: "#299e60" }}
      />
    </div>
  );
};

export default Loader;
